import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const testimonials = [
    {
      name: 'Carlos Mendes',
      role: 'Colecionador',
      text: 'Atendimento impecável e total transparência. Adquiri meu Submariner com total confiança.',
      rating: 5
    },
    {
      name: 'Patricia Silva',
      role: 'Investidora',
      text: 'A ART TIME transformou minha experiência de compra de relógios de luxo. Exclusividade e expertise em cada detalhe.',
      rating: 5
    },
    {
      name: 'Ricardo Almeida',
      role: 'Empresário',
      text: 'Vendi meu relógio com total segurança e avaliação justa. Recomendo sem hesitar.',
      rating: 5
    }
  ];

  return (
    <section
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
      data-testid="testimonials-section"
    >
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
          Depoimentos
        </div>
        <h2 className="font-serif text-3xl md:text-5xl text-white tracking-tight">
          O Que Dizem Nossos Clientes
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            className="border border-white/5 p-8 hover:border-[#C9A646]/30 transition-colors duration-500"
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            data-testid={`testimonial-${index}`}
          >
            <div className="flex gap-1 mb-6">
              {[...Array(testimonial.rating)].map((_, i) => (
                <Star key={i} size={16} className="text-[#C9A646] fill-[#C9A646]" />
              ))}
            </div>
            
            <p className="font-sans text-base text-[#A3A3A3] leading-relaxed mb-8 italic">
              "{testimonial.text}"
            </p>
            
            <div>
              <div className="font-serif text-lg text-white mb-1">{testimonial.name}</div>
              <div className="font-sans text-sm text-[#C9A646]">{testimonial.role}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
